import { __generator, __values } from "tslib";
var CacheableList = /** @class */ (function () {
    function CacheableList(factory) {
        this.cache = null;
        this.factory = factory;
    }
    CacheableList.prototype[Symbol.iterator] = function () {
        var _a, _b, item, e_1_1, _c, _d, item, e_2_1;
        var e_1, _e, e_2, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!(this.cache === null)) return [3 /*break*/, 9];
                    this.cache = [];
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 6, 7, 8]);
                    _a = __values(this.factory()), _b = _a.next();
                    _g.label = 2;
                case 2:
                    if (!!_b.done) return [3 /*break*/, 5];
                    item = _b.value;
                    this.cache.push(item);
                    return [4 /*yield*/, item];
                case 3:
                    _g.sent();
                    _g.label = 4;
                case 4:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _g.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
                case 9:
                    _g.trys.push([9, 14, 15, 16]);
                    _c = __values(this.cache), _d = _c.next();
                    _g.label = 10;
                case 10:
                    if (!!_d.done) return [3 /*break*/, 13];
                    item = _d.value;
                    return [4 /*yield*/, item];
                case 11:
                    _g.sent();
                    _g.label = 12;
                case 12:
                    _d = _c.next();
                    return [3 /*break*/, 10];
                case 13: return [3 /*break*/, 16];
                case 14:
                    e_2_1 = _g.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 16];
                case 15:
                    try {
                        if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 16: return [2 /*return*/];
            }
        });
    };
    return CacheableList;
}());
export { CacheableList };
